import { toast } from "sonner";
import { Copy, KeyRound } from "lucide-react";
import { inputDark } from "@/components/shared/AdminKit";
import { useTr } from "@/lib/tr";

export function TempPasswordBox({ password, onClose }) {
  const tr = useTr();
  if (!password) return null;
  return (
    <div className="rounded-xl border border-emerald-700/40 bg-emerald-500/10 p-4" data-testid="temp-password-box">
      <div className="flex items-center gap-2 text-sm font-medium text-emerald-300"><KeyRound className="h-4 w-4" /> {tr("Mot de passe temporaire (affiché une seule fois)", "Temporary password (shown only once)")}</div>
      <div className="mt-2 flex items-center gap-2">
        <input readOnly value={password} data-testid="temp-password-value" className={inputDark + " font-mono"} />
        <button type="button" onClick={() => { navigator.clipboard.writeText(password); toast.success(tr("Copié", "Copied")); }} data-testid="temp-password-copy" className="rounded-lg border border-slate-700 p-2 hover:bg-slate-800"><Copy className="h-4 w-4" /></button>
      </div>
      <p className="mt-2 text-xs text-slate-400">{tr("Transmettez-le à l'agent par un canal sûr. Il devra le changer à sa première connexion. Il ne pourra plus être affiché.", "Give it to the agent through a safe channel. They must change it at first login. It cannot be shown again.")}</p>
      {onClose && <button type="button" onClick={onClose} data-testid="temp-password-close" className="mt-2 text-xs text-slate-400 hover:text-white">{tr("J'ai noté le mot de passe", "I saved the password")}</button>}
    </div>
  );
}
